import { Button, Collapse, List } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import ServiceQuestion from "../../Classes/ServiceQuestion";
import { pickAFileSliceDispatch, serviceQuestionViewerSliceDispatch, serviceQuestionModalSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import ServiceQuestionModal from "../ServiceQuestionModal/ServiceQuestionModal";

const ServiceQuestionViewer = () => {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentServices = useSelector((state: any) => state.pickAFile.serviceList);
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);
    const currentServiceBrandQuestions = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);
    const open = useSelector((state: any) => state.serviceQuestionModal.open);

    const activeIndex = useSelector((state: any) => state.serviceQuestionViewer.activeIndex);

    const dispatch = useDispatch();

    const { CreateContentsFromStates } = ReduxHelpers();

    function serviceQuestionDeleter(questionIdToDelete, serviceIdToDelete) {

        let filteredServices = currentServiceQuestions.filter(serviceQuestion =>
            !(
                (serviceQuestion.assistanceServiceId == parseInt(serviceIdToDelete) || serviceQuestion.assistanceServiceId == serviceIdToDelete) &&
                (serviceQuestion.questionId == parseInt(questionIdToDelete) || serviceQuestion.questionId == questionIdToDelete)
            )
        );

        dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: filteredServices })

        CreateContentsFromStates({ serviceQuestions: filteredServices });

        return filteredServices;
    }

    const handleClick = (_, index) => {
        if (!open) {
            console.log(index);
            dispatch({ type: serviceQuestionViewerSliceDispatch.setActiveIndex, payload: parseInt(index) });
            dispatch({ type: serviceQuestionModalSliceDispatch.setServiceId, payload: index });
        }
    }

    function getQuestionDataKey(questionId) {
        let match = currentQuestions?.find(p => p.questionId == questionId)

        if (match) {
            return match.dataKey;
        }
        return null;
    }

    function getServiceById(serviceId) {
        let match = currentServices?.find(p => p.serviceId == serviceId)
        if (match) {
            return match.serviceName
        }
        return null;
    }


    const HandleDelete = (event) => {
        serviceQuestionDeleter(event.currentTarget.id, event.currentTarget.getAttribute('data-service'))
    }

    function compareServiceIds(r, s) {

        if (s.serviceId == r) {
            return (true)
        } else {
            return (false)
        }
    }

    function getGroupedServices() {
        if (currentServiceQuestions) {
            let groupedByServiceIds = currentServiceQuestions?.reduce((questions, { assistanceServiceId, questionId }) => {
                (questions[assistanceServiceId] = questions[assistanceServiceId] || []).push(questionId);
                return questions;
            }, {})

            let listOfServicesThatAreUsed = Object.entries(groupedByServiceIds)

            let onesToAdd = currentServices?.filter(s => !listOfServicesThatAreUsed?.some(r => compareServiceIds(r[0], s)))


            if (onesToAdd?.length > 0) {
                for (let itemToAdd in onesToAdd) {
                    groupedByServiceIds[onesToAdd[itemToAdd].serviceId] = []
                }
            }
            return groupedByServiceIds
        }
        return null;
    }

    let groupedByServiceIds = getGroupedServices()

    if (groupedByServiceIds) {

        const allServicesQuestions =
            <List>
                {
                    Object.entries(groupedByServiceIds).map(([key, value]: [string, any]) => {

                        const ListOfQuestions = (
                            <List
                                dataSource={value?.sort((a: any, b: any) => a > b ? 1 : -1)}
                                renderItem={(currentQuestionId: any) => (
                                    <div>
                                        <List.Item key={currentQuestionId}>
                                            <div>
                                                <Button id={currentQuestionId} data-service={key}
                                                    onClick={HandleDelete}>Delete</Button>
                                                {getQuestionDataKey(currentQuestionId)}
                                            </div>
                                        </List.Item>
                                    </div>
                                )}
                            />
                        )

                        let defaultNewServiceQuestion = new ServiceQuestion();  //Empty default question
                        defaultNewServiceQuestion.assistanceServiceId = parseInt(key);
                        //Filter out any questions that are already part of the service
                        let filteredQuestions = currentServiceQuestions.filter(p => p.assistanceServiceId == key);
                        let questionsToShow = currentQuestions?.filter(p => 
                                !filteredQuestions.some(r => r.questionId == p.questionId) && 
                                !currentServiceBrandQuestions.some(sbq => sbq.assistanceServiceId == key && sbq.questionId == p.questionId))
                        let usedQuestionCount = currentQuestions?.filter(p => filteredQuestions.some(r => r.questionId == p.questionId))?.length

                        const header = <div><ServiceQuestionModal questions={questionsToShow}
                            caption={"Add Question(s) to " + key}
                            serviceQuestion={defaultNewServiceQuestion} />{getServiceById(key)} - ({usedQuestionCount})</div>
                        return (
                            <List>
                                <Collapse
                                    defaultActiveKey={[activeIndex]}
                                    style={{ width: '100%' }}
                                >
                                    <Collapse.Panel key={key} header={header} style={{ width: '100%' }}>
                                        {ListOfQuestions}
                                    </Collapse.Panel>
                                </Collapse>
                            </List>
                        )


                    })}
            </List>
        return <div>{allServicesQuestions}</div>
    }
    return <div></div>
}


export default ServiceQuestionViewer;